import {
  ChexFieldNames,
  ChexFieldValues,
  ChexNestedFormValue,
} from "checkout-query-client/types/chex-form-fields";

export const matchesField =
  (field: ChexFieldNames, fieldToMatch: ChexFieldNames, formId?: string) =>
  (_: $TSNoType, values: ChexNestedFormValue) => {
    if (!formId) return;

    const formValues: ChexFieldValues = values[formId];
    return (
      formValues[fieldToMatch] === undefined ||
      formValues[fieldToMatch] == formValues[field] ||
      formValues[fieldToMatch] == ""
    );
  };
